export const breakpoints = {
  xl: 1650,
  lg: 1280,
  md: 1080,
}
